'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { FC, MouseEvent, useRef, useState } from 'react';
import { Typography } from '@/components/shared/Typography';
import cn from '@/helpers/cn';
import useDevice from '@/hooks/useDevice';
import { useModal } from '@/hooks/useModal';
import { MemberInfo, TeamDto } from '../types';
import css from './style.module.scss';
interface Props {
  data: TeamDto;
}
const TeamList: FC<Props> = t0 => {
  const $ = _c(27);
  const {
    data
  } = t0;
  const device = useDevice();
  const {
    openModal
  } = useModal();
  const wrapperRef = useRef(null);
  const [active, setActive] = useState(null);
  const [photoPosition, setPhotoPosition] = useState(null);
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] !== active || $[1] !== data.team || $[2] !== device || $[3] !== openModal || $[4] !== photoPosition) {
    const flatList = data.team.flatMap(_temp);
    const handleEnter = (member, e) => {
      if (!wrapperRef.current) {
        return;
      }
      const wrapperRect = wrapperRef.current.getBoundingClientRect();
      const itemRect = e.currentTarget.getBoundingClientRect();
      const relativeTop = itemRect.top - wrapperRect.top + itemRect.height / 2;
      setActive(member);
      setPhotoPosition({
        top: relativeTop
      });
    };
    let t7;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = () => {
        setActive(null);
        setPhotoPosition(null);
      };
      $[11] = t7;
    } else {
      t7 = $[11];
    }
    const handleLeave = t7;
    let t8;
    if ($[12] !== openModal) {
      t8 = member_0 => {
        openModal("TEAM_MEMBER_INFO", {
          member: member_0
        });
      };
      $[12] = openModal;
      $[13] = t8;
    } else {
      t8 = $[13];
    }
    const openMemberModal = t8;
    t3 = wrapperRef;
    t4 = css.wrapper;
    t5 = device === "desktop" ? <ul className={css.list}>{flatList.map(member_1 => <li key={member_1.name} className={cn(css.item, active?.name === member_1.name ? css.active : "")} onMouseEnter={e_0 => handleEnter(member_1, e_0)} onMouseLeave={handleLeave}><Typography className={css.name} variant="h6-regular" tag="span">{member_1.name}</Typography>{member_1.description ? <Typography className={css.description} variant="body-m" tag="p">{member_1.description}</Typography> : null}<Typography className={css.role} variant="h6-regular" tag="span">{member_1.role}</Typography></li>)}</ul> : data.team.map((department_0, index) => <div key={index}><Typography className={css.departmentTitle} variant="h3" tag="h3">{department_0.departmentTitle}</Typography><ul className={css.list}>{department_0.members.map(member_2 => <li key={member_2.name} className={css.item} onClick={() => openMemberModal(member_2)}><Typography className={css.name} variant="h6-regular" tag="span">{member_2.name}</Typography><Typography className={css.role} variant="h6-regular" tag="span">{member_2.role}</Typography></li>)}</ul></div>);
    if ($[14] !== active || $[15] !== photoPosition) {
      t6 = active && active.image && photoPosition ? <div className={css.photoWrap} style={{
        top: `${photoPosition.top}px`
      }}><Image src={active.image.url} alt={active.name} className={css.photo} width={255} height={285} preload={false} /></div> : null;
      $[14] = active;
      $[15] = photoPosition;
      $[16] = t6;
    } else {
      t6 = $[16];
    }
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = {
        display: "none"
      };
      $[17] = t1;
    } else {
      t1 = $[17];
    }
    t2 = flatList.map(_temp2);
    $[0] = active;
    $[1] = data.team;
    $[2] = device;
    $[3] = openModal;
    $[4] = photoPosition;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
    t6 = $[10];
  }
  let t7;
  if ($[18] !== t1 || $[19] !== t2) {
    t7 = <div style={t1}>{t2}</div>;
    $[18] = t1;
    $[19] = t2;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== t3 || $[22] !== t4 || $[23] !== t5 || $[24] !== t6 || $[25] !== t7) {
    t8 = <div ref={t3} className={t4}>{t5}{t6}{t7}</div>;
    $[21] = t3;
    $[22] = t4;
    $[23] = t5;
    $[24] = t6;
    $[25] = t7;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  return t8;
};
export default TeamList;
function _temp(department) {
  return department.members;
}
function _temp2(member_3) {
  return <Image key={member_3.name} preload={true} src={member_3.image?.url || ""} width={255} height={285} alt={member_3.image?.alternativeText || member_3.name} />;
}